export function OutlineLightbulbSlashIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.49899 6.5C6.2062 7.10478 6.01901 7.76237 5.95181 8.44875C5.86541 9.29353 5.95181 10.1047 6.1822 10.8583C6.56619 12.1255 7.35337 12.4086 7.97256 13.6374C8.27975 14.2422 8.61574 15.1734 8.62054 16.5221H15.3692C15.374 16.1285 15.4028 15.7734 15.4508 15.4518"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M8.87012 3.87396C9.5997 3.43237 10.4253 3.13957 11.3085 3.03878C14.9804 2.63079 18.0859 5.49631 18.0859 9.08662C18.0859 9.701 17.9947 10.301 17.8219 10.8578C17.6491 11.4194 17.4139 11.8033 17.1499 12.1489"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M12.0046 15.9898V12.0059"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.63493 16.5503V18.7534C8.63493 19.9918 9.6381 20.9998 10.8813 20.9998H13.118C14.3564 20.9998 15.3644 19.9966 15.3644 18.7534V16.5599C15.3644 16.5599 15.3644 16.5359 15.3644 16.5215H8.63013C8.63013 16.5215 8.63013 16.5407 8.63013 16.5503H8.63493Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 3L20.9995 20.9995"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
